import React, { useState } from 'react';
import { CDN_TYPE_GAME, imageUrlCDN } from 'utils';

import { ChipsItem, Label } from '@atlas/ui';

export const CasinoCategory = ({
  InfoGamesList,
  games,
  iconUrl,
  id,
  isImgFetchHighPriority = false,
  isImgLoadingEager = false,
  name,
  showCategoryHandler,
  sliderSettings,
}) => {
  const [isShowImg, toggleVisibilityImg] = useState(!!iconUrl);
  const handleError = () => toggleVisibilityImg(false);

  return (
    <div className="casino__category" key={id}>
      <div className="casino__category__header">
        <div className="casino__category__name">
          {isShowImg && (
            <img
              alt={name}
              className="casino__category__icon"
              fetchPriority={isImgFetchHighPriority ? 'high' : 'auto'}
              loading={isImgLoadingEager ? 'eager' : 'lazy'}
              onError={handleError}
              src={encodeURI(imageUrlCDN(iconUrl, CDN_TYPE_GAME))}
            />
          )}
          <h2 className="casino__category__title">{name}</h2>
        </div>
        {showCategoryHandler && (
          <ChipsItem
            label={<Label className="casino__category__title__view" message="View_All" />}
            onClick={showCategoryHandler(id)}
          />
        )}
      </div>
      <InfoGamesList
        games={games}
        homePageCasino
        isImgFetchHighPriority={isImgFetchHighPriority}
        isImgLoadingEager={isImgLoadingEager}
        isResolved={games}
        sliderSettings={sliderSettings}
      />
    </div>
  );
};
